import { req,fetch,imFetch  } from './axiosFun';

// 登录
export const login = (params) => { return req("post", "/api/login", params) };

// 注册 - 获取短信验证码
export const sendSms = (params) => { return req("get", "/common/sendSms", params) };

// 注册提交表达
export const register = (params) => { return req("post", "/custom/xunyou/api/registerPhone", params) };
// 注册协议
export const registerBook = (params) => { return req("post", "/custom/xunyou/protocol/api/list", params) };

//未登录  忘记密码 ---
export const forgotPwd = (params) => { return req("post", "/custom/xunyou/api/forgotPwdByPhone", params) };
//不需要原密码直接修改用户密码 ---
export const resetPassword = (params) => { return req("post", "/custom/xunyou/api/resetPassword", params) };

// 忘记密码 --- 检测账户是否存在
export const checkloginPhone = (params) => { return req("get", `/custom/xunyou/api/checkloginPhone`, params) };
// 忘记密码 --- 短信校验
export const querySendDetails = (params) => { return req("post", "/common/querySendDetails", params) };

// 修改支付密码
export const editPayPassword= (params) => { return req("post", "/portal/editPayPaswByPhone", params) };



//  查询支付状态
export const payStatus = (params) => { return req("post", "/custom/xunyou/api/pay/alipayQuery", params) };

export const xy_personvalue = (params) => { return req("post", "/custom/xunyou/xy_personvalue/api/deal", params) };

// 获取余额支付比例
export const getBalancePayProportion = (params) => { return req("post", "/portal/api/getBalancePayProportion", params) };


/**
 * 订单管理-交易订单
 **/
// 红包查询
export const redEnvelope = (params) => { return req("post", "/custom/xunyou/api/redlist", params) };
// 红包领取
export const getredEnvelope = (params) => { return req("post", "/custom/xunyou/red_envelopes_record/api/add", params) };
// 我领取的红包y
export const getMyred = (params) => { return req("post", "/custom/xunyou/red_envelopes_record/api/list", params) };

// 商家入驻图片
export const pageConfigImg = (params) => { return req("post", "/custom/xunyou/page_config/api/list", params) };
// 商家入驻协议内容
export const agreementContent  = (params) => { return req("post", "/custom/xunyou/mDescription/api/list", params) };

// 商家入驻欢迎页面下三个tabs
export const agreementThreelist = (params) => { return req("post", "/portal/agreementlist", params) };
// 商家入驻状态
export const getMercharntStep = (params) => { return req("post", "/portal/pc/getMercharntStep", params) };

// 商家入驻状态查询
export const getMercharntStatus = (params) => { return req("post", "/portal/pc/getMercharntStatus", params) };//返回结果的状态1.审核中，2.审核通过

// 商家入驻 申请表单
export const merchantForm = (params) => { return req("post", "/portal/mercharnt_add", params) };
export const merchantReApply = (params) => { return req("post", "/portal/pc/reApplyInfo", params) };
export const refreshUser = (params) => { return req("post", "/api/refreshUserInfo", params) };
// 商家入驻下拉框
// 店铺等级
export const slevelList = (params) => { return req("post", "/portal/slevelList", params) };
// 店铺分类
export const storeClassList = (params) => { return req("post", "/custom/xunyou/classification/api/storeClasslist", params) };
// 店铺类目
export const leftmenu = (params) => { return req("get", "/portal/mainproduct", params) };
// 公司地址下拉框
export const area_list = (params) => { return req("post", "/portal/area_list", params) };
// 商家入驻付费清单
export const merchants_pay_list = (params) => { return req("post", "/portal/pc/merchants_pay_list", params) };
// 重新申请商家入驻
export const reApplyApi = (params) => { return req("post", "/portal/pc/reApply", params) };


//新增保证金记录
export const addMargin = (params) => { return req("post", "/custom/xunyou/margin/api/add", params) };


// 商家入驻-合同签订及缴费
export const merchantpayMoney = (params) => { return req("post", "/custom/xunyou/merchant/api/merchantedit", params) };

// 品牌
export const brandListApi = (params) => { return req("post", "/portal/brandlist", params) };

// 查询购物车接口
export const shoppingCartlist = (params) => { return req("post", "/portal/cartlist", params) };
// 添加购物车
export const addShoppingCart = (params) => { return req("post", "/custom/xunyou/cart/api/shoppingCart/add", params) }; // 待检测
// 购物车中删除
export const shoppingCartDelete = (params) => { return req("post", "/custom/xunyou/cart/api/shoppingCart/remove", params) }; // 待检测


// 普通 -  商品列表  批发市场- 商品列表
export const commoditylist = (params) => { return req("post", "/custom/xunyou/commodity/api/commoditylist", params) }; // stype  店铺类型（1.供货商|2.普通）
// 获取商品规格
export const getAttributelist = (params) => { return req("post", "/custom/xunyou/bg_specification_details/api/getAttributelist", params) };
// /custom/xunyou/bg_specification_details//getAttributelist
// 点击商品规格，获取相应的价格
export const getSpecificationDetail = (params) => { return req("post", "/custom/xunyou/bg_specification_details/api/getSpecificationDetail", params) };
// 点击商品规格，获取规格
export const getSpecificationselect = (params) => { return req("post", "/custom/xunyou/bg_specification_details/api/getSpecificationselect", params) }; //specificationId
// /custom/xunyou/bg_specification_details//getAttributelist

// /api/getSpecificationselect

// 商品列表分类
export const categorylist = (params) => { return req("post", "/custom/xunyou/category/api/categorylist", params) };
// 商品详情页面
// export const categorylist = (params) => { return req("post", "/custom/xunyou/category/api/categorylist", params) };
// 商品咨询
export const goodsAdvice = (params) => { return req("post", "/custom/xunyou/advisory/api/list", params) };
// 商品咨询----提问
export const addgoodsAdvice = (params) => { return req("post", "/custom/xunyou/advisory/api/add", params) };



// 批发市场- 商品列表 查询商品状态
// 0.未签约 1.审核中 2.签约通过 3.审核驳回 4.商品未签约 5.已经分销 6.一键分销
export const getDistStatus = (params) => { return req("post", "/portal/pc/getDistStatus", params) };
// 申请成为分销商
export const distributors_add = (params) => { return req("post", "/portal/pc/distributors_add", params) };
// 一键分销
export const WholesaleGoods_add = (params) => { return req("post", "/portal/pc/WholesaleGoods_add", params) };





// 订单详情页面（地址增删改查）
// 地址查询
export const addresslist = (params) => { return req("post", "/custom/xunyou/user_address/api/addresslist", params) };
// 增加地址
export const address_add = (params) => { return req("post", "/custom/xunyou/user_address/api/user_address/add", params) };
// 删除地址
export const address_remove = (params) => { return req("post", "/custom/xunyou/user_address/api/user_address/remove", params) };
// 修改地址
export const address_saveedit = (params) => { return req("post", "/custom/xunyou/user_address/api/user_address/saveedit", params) };
// 查询店铺运费信息
// export const getStoreFreight = (params) => { return req("post", "/portal/pc/getStoreFreight", params) };
export const getStoreFreight = (params) => { return req("post", "/portal/pc/getStoreFreight", params)};

// /portal/pc/getStoreFreight
// 提交订单
// export const addOrder = (params) => { return req("post", "/portal/add_order", params) };
export const addOrder = (params) => { return req("post", "/portal/pc/add_order", params)};

// 通过 立即购买按钮 跳转过来 下单的接口
export const immediatePlaceOrder = (params) => { return req("post", "/portal/pc/immediatePlaceOrder", params)};

// 跳到下单详情页面前，掉这个接口
export const get_order = (params) => { return req("post", "/get_order", params) };
// 下单后显示订单
export const showorderList = (params) => { return req("post", "/portal/pc/userOrderList", params) };

// 积分订单查询
export const pointList = (params) => { return req("post", "/custom/xunyou/xy_order/api/pointList", params) };


/** 我的订单 **/
// 搜索
export const searchOrder = (params) => { return req("post", "/custom/xunyou/user_address/api/user_address/saveedit", params) };
// 我的订单查询
export const orderLists = (params) => { return req("post", "/custom/xunyou/user_address/api/user_address/saveedit", params) };
// 立即支付
export const payFor = (params) => { return req("post", "/custom/xunyou/user_address/api/user_address/saveedit", params) };
// 退款
export const addbackMoney = (params) => { return fetch("post", "/custom/xunyou/after_sale/api/apply", params) };
// 退款原因查询
export const getDictData = (params) => { return req("post", "/common/getDictData", params) };
// 退款列表
export const backMoneyList = (params) => { return req("post", "/custom/xunyou/after_sale/api/listMulGood", params) };
// 撤销退款申请
export const remove_after_sale = (params) => { return req("post", "/custom/xunyou/after_sale/api/remove_after_sale", params) };


// 取消订单
export const cancleOrderItem = (params) => { return req("post", "/portal/pc/cancelOrder", params) };
// 移除订单
export const removeOrderItem = (params) => { return req("post", "/portal/pc/removeOrder", params) };
// 确认收货
export const confirmRceiptItem = (params) => { return req("post", "/portal/order_End", params) };
// 物流查询
export const kuaidi100 = (params) => { return req("post", `/custom/xunyou/api/kuaidi/kuaidi100Record`, params) };
// 查看订单详情
export const orderDetailItem = (params) => { return req("post", "/custom/xunyou/user_address/api/user_address/saveedit", params) };

/** 关注中心 **/
// 新增足迹
export const footprint_add = (params) => { return req("post", "/custom/xunyou/footprint/api/addFootprint", params) };
// 删除足迹
export const footprint_remove = (params) => { return req("post", "/custom/xunyou/footprint/api/removeFootprint", params) };
// 我的足迹
export const footprint_list = (params) => { return req("post", "/custom/xunyou/footprint/api/footprint_list", params) };
// 商品/店铺收藏
export const collection_list = (params) => { return req("post", "/custom/xunyou/collectionMG/api/collection_list", params) }; //type:1:商品；2：店铺；
// 添加收藏
export const addCollection = (params) => { return req("post", "/custom/xunyou/collectionMG/api/addCollection", params) }; //type:1:商品；2：店铺；
// 取消收藏
export const removeCollection = (params) => { return req("post", "/custom/xunyou/collectionMG/api/removeCollection", params) }; //type:1:商品；2：店铺；

/** 个人中心 **/
// 我的信息
export const userDetails = (params) => { return req("get", `/portal/userDetails/${params.userId}`, params) };
//账户信息编辑
export const editUser = (params) => { return req("post", '/portal/editUser', params) };
//已登录 -- 修改密码
export const resetPwd = (params) => { return req("post", "/custom/xunyou/api/resetPwd", params) };

/** 财产中心 */
export const integralList = (params) => { return req("post", "/custom/xunyou/integral/api/list", params) };
/**
 * 首页
 */

// 顶部热门搜索
export const hot_search = (params) => { return req("post", "/custom/xunyou/api/hot_search", params) };
// 顶部默认搜索
export const search_list = (params) => { return req("post", "/custom/xunyou/api/search_list", params) };

//轮播图
export const swiperList = (params) => { return req("post", "/custom/xunyou/promotion/api/swiperlist", params) };

//热门分类图
export const categoryHotList = (params) => { return req("post", "/portal/storeCategoryHot_list", params) };

//菜单
export const navList = (params) => { return req("post", "/portal/navlist", params) };

//左侧菜单
export const leftMenuList = (params) => { return req("get", "/portal/leftmenu", params) };

// 通知
export const noticeList = (params) => { return req("post", "/custom/xunyou/api/articleList", params) };

/**
 * 店铺街
 */
//店铺列表
// export const storerList = (params) => { return req("post", "/portal/pc/merchantlist", params) };
export const storeList = (params) => { return req("post", "/portal/pc/merchantlistPC", params) };
export const storeInfo = (params) => { return req("post", "/portal/pc/merchantApiDetail", params) };
 // 查询店铺的用户管理
export const imUserID = (params) => { return req("post", "/portal/pc/getImUserID", params) };

export const imFriends = (params) => { return req("post", "/custom/xunyou/im_friends/api/add", params) };
// 店铺页面 - 查询店铺轮播图
export const storeSwiperList = (params) => { return req("post", "/custom/xunyou/store_mg/store/store_info/api/list", params) };
// 店铺页面 - 查询店铺分类(內)列表
export const storeCategory = (params) => { return req("post", "/custom/xunyou/sort/api/list", params) };


/** 支付中心 */
// 交易流水
export const payList = (params) => { return req("post", "/custom/xunyou/user_balance_flow/api/payList", params) };
// 余额流水查询
export const balanceTurnover = (params) => { return req("post", "/custom/xunyou/user_balance_flow/api/list", params) };
// 点击充值 recharge
export const recharge = (params) => { return req("post", "/portal/pc/merchantlist", params) };

/** 用户中心 */
// 账号绑定-实名认证
export const queryUserStatus = (params) => { return req("post", "/portal/queryUserStatus", params) };
// 账号绑定-手机绑定
export const bindingPhone = (params) => { return req("post", "/portal/bindingPhone", params) };
// 账号绑定-邮箱绑定
export const bindingEmail = (params) => { return req("post", "/portal/bindingEmail", params) };
//  账号绑定-发送邮箱验证码
export const sendEmail = (params) => {return req("get", `/common/sendEmail?email=${params.email}`, params) };
//  账号绑定-邮箱验证码校验
export const vEmail = (params) => {return req("post", '/common/vEmail', params) };
// 账号绑定-实名认证
export const authentication = (params) => { return req("post", "/portal/authentication", params) };

/**  客户服务  * */
// 咨询文章分类列表
export const newsCategory = (params) => { return req("post", "/custom/xunyou/article_category/api/newsCategoryTree", params) };
// 帮助文章分类列表
export const helpCategory = (params) => { return req("post", "/custom/xunyou/article_category/api/noticeCategoryTree", params) };
// 文章列表接口
export const articleList = (params) => { return req("post", "/custom/xunyou/help_article/api/list", params) };
// 文章（和公告）详情
export const articleDetail = (params) => {return req("post", '/custom/xunyou/help_article/api/articleDetail', params) };

// 个人账户汇总
export const getUserPay = (params) => {return req("get", `/custom/xunyou/api/getUserPay/${params.userId}`, params) };



/** 评论 */
// 评论列表
export const commentList = (params) => { return req("post", "/custom/xunyou/evaluation/api/list", params) };
// 发表评论
export const postComment = (params) => {return fetch("post", '/custom/xunyou/evaluation/api/addEvaluation', params) };
// 回复评论
export const replayComment = (params) => {return req("post", `/custom/xunyou/deal_order_evaluation_reply/api/add`, params) };
// 删除评论
export const deleteComment = (params) => {return req("post", `/custom/xunyou/evaluation/api/remove`, params) };

// 商品评价详情
export const findEvaluation = (params) => { return req("post", "/custom/xunyou/evaluation/api/findEvaluation", params) };

/** 资金 */
// 充值卡校验是否存在
export const checkcard = (params) => { return req("post", "/portal/checkcard", params) };
// 充值卡充值
export const rechargeCard_recharge = (params) => { return req("post", "/portal/rechargeCard_recharge", params) };
// 充值卡流水列表
export const recharge_card_turnover = (params) => { return req("post", "/custom/xunyou/recharge_card_turnover/api/list", params) };
// // 余额支付API
export const balancePay = (params) => { return req("post", "/portal/balancePay", params) };

// 混合支付
export const balancePayMax = (params) => { return req("post", "/portal/balancepay_max", params) };

/* 积分商城 */
export const presentlist = (params) => { return req("post", "/custom/xunyou/points_exchange/api/presentlist", params) };

/* 限时折扣 */
// activityTypeId=2 2折扣 6秒杀
export const activityCommodityList = (params) => { return req("post", "/custom/xunyou/commodity/api/activityCommodityList", params) };

/* 秒杀 */
export const seckillCommodityList = (params) => { return req("post", "/custom/xunyou/commodity/api/seckillCommodityList", params) };
// /center/custom/xunyou/commodity/api/seckillCommodityList

/** 首页 */
// 装修接口
// export const getPage = (params) => {return req("get", `/custom/xunyou/api/getPage?id=${params.id}`, params) };
export const getPage = (params) => {return req("get", `/portal/pc/getPcPage?id=${params.id}`, params) };

/** 专题页 */
// 装修接口
// export const getPage = (params) => {return req("get", `/custom/xunyou/api/getPage?id=${params.id}`, params) };
export const getTopciPage = (params) => {return req("get", '/portal/pc/getPcTopicPage', params) };


/* 改造后的接口 */
// 商品列表
export const commodities = (params) => { return req("get", "/center/rest-apis/commodities", params) };

/** 文章评价 */
//新增评论接口
export const addChat = (params) => { return req("post", "/custom/xunyou/context/api/add", params) }
// 查询评论列表
export const getChat = (params) => { return req("post", "/custom/xunyou/context/api/list", params) }
// 渲染店铺入驻协议
export const shopPass = (params) => { return req("post", "/custom/xunyou/description/api/list", params) }
// 版权名称可配
export const copyRight = (params) => { return req("post", "/custom/xunyou/information/api/list", params) }
// 自定义图片设置
export const setImage = (params) => { return req("post", "/custom/xunyou/imageInformation/api/list", params) }

export const fetchApplyStoreClose = (params) => { return req("post", "/portal/pc/shutMerchant", params) }
export const fetchUndoStoreClose = (params) => { return req("post", "/portal/pc/shutMerchantCancel", params) }

/**------------------------商品----------------------------**/
export const fetchGoodSkus = (params) => { return req("post", "/custom/xunyou/bg_specification_details/api/querySkus", params) }
export const fetchStoreData = (params) => { return req("post", "/portal/pc/queryMerchantStatusInfo", params) }
export const fetchBrandList = (params) => { return req("post", "/custom/xunyou/typeof/api/getBrandList", params) }

/**--------------------- 代金券 -----------------------**/
export const fetchOrderCashCoupons = (params) => { return req("post", "/system/userVoucher/api/queryOrderAvailVoucher", params) }
export const fetchUserCashCoupons = (params) => { return req("post", "/system/userVoucher/api/list", params) }
export const fetchFreshCashCoupons = (params) => { return req("post", "/system/userVoucher/api/receiveVoucher", params) }
export const fetchMerchantAccountBalance = (params) => { return req("post", "/custom/merchantAccount/api/merchantAccount", params) }
export const fetchMerchantAccountInfo = (params) => { return req("post", "/custom/merchantAccount/api/merchantSettlement", params) }
export const fetchMerchantAccountInfoUpdate = (params) => { return req("post", "/custom/merchantAccount/api/updateMerchantSettlement", params) }
export const fetchMerchantAccountFlow = (params) => { return req("post", "/custom/merchantAccount/api/accountFlow", params) }
export const fetchMerchantAccountWithdrawFlow = (params) => { return req("post", "/custom/merchantAccount/api/withdrawFlow", params) }
export const fetchMerchantAccountDefaultData = (params) => { return req("post", "/custom/merchantAccount/api/querySettlementDefaultConfig", params) }
export const fetchMerchantWithdraw = (params) => { return req("post", "/custom/merchantAccount/api/withdraw", params) }
export const fetchPaySuccess = (params) => { return req("post", "/custom/xunyou/xy_personvalue/api/dealmax", params) }

/**-------------------------订单----------------------------**/
export const fetchPlaceOrder = (params) => { return fetch("post", "/beartech/order/api/takeOrder", params) }
export const fetchOrderDetail = (params) => { return req("post", "/portal/pc/orderDetail", params) }
export const fetchOrderPay = (params) => { return fetch("post", "/beartech/flow/api/doPay", params) }
export const fetchOrderPayStatus = (params) => { return req("post", "/beartech/flow/api/queryOrder", params) }
export const fetchOrderCancel = (params) => { return fetch("post", "/beartech/order/api/cancelOrder", params) }
export const fetchOrderConfirm = (params) => { return fetch("post", "/beartech/order/api/confirmOrder", params) }
export const fetchOrderDetailByOrderNos = (params) => { return fetch("post", "/beartech/order/api/queryOrderList", params) };
export const fetchOrderQrcode = (params) => { return fetch("post", "/beartech/order/api/queryOrderSellCode", params) };
export const fetchDelayConfirm = (params) => { return req("post", "/portal/order/delayDelivery", params) };
export const fetchRefundAppeal = (params) => { return req("post", "/custom/xunyou/return_form/api/applyRegHandle", params) };

/**---------------------------换取im登录令牌--------------------------------**/
export const fetchImToken = (params) => { return req("post", "/custom/xunyou/user/api/imLogin", params) }
export const fetchReceiverIm = (params) => { return req("post", "/beartech/customerService/api/getCustomerUser", params) }

export const fetchLiveList = (params) => { return fetch("post", "/beartech/wx/api/getLiveRoomListPage", params) }
export const fetchLiveCode = (params) => { return fetch("post", "/beartech/wx/api/getMpShareQrCode", params) }

/**---------------------------我的邀请--------------------------------**/
export const fetchTodayData = (params) => { return req("post", "/custom/recommendOrder/api/recommendTodayStatis", params) }
export const fetchInviteStoreList = (params) => { return req("post", "/portal/pc/merchantlistApi", params) }
export const fetchInviteSummery = (params) => { return req("post", "/custom/recommendOrder/api/recommendStatisticSum", params) }
export const fetchInviteDataFlow = (params) => { return req("post", "/custom/recommendOrder/api/detailList", params) }

/**------------------------------------所有json加密请求---------------------------------------**/
export const fetchNoticeList = (params) => { return imFetch("post", "/im/messageNotice/userPage", params) }
export const fetchReadNotice = (params) => { return imFetch("post", "/im/messageNotice/readNotice", params) }
export const fetchUnreadCount = (params) => { return imFetch("post", "/im/userFriend/unreadCount", params) }



// WEBPACK FOOTER //
// ./src/api/xunyou.js